import React from 'react';
import DENTToothSurface from './DENTToothSurface';
import {
	Tooth,
	ToothSurface,
	ToothToothWearZone,
} from '../../../../graphql/graphql';
import { ToothViewData } from './teethData';

interface Props {
	data: Tooth;
	toothViewData: ToothViewData;
}

const ABRASION_SURFACES = {
	[ToothToothWearZone.Buccal]: ToothSurface.CervicalBuccal,
	[ToothToothWearZone.Palatal]: ToothSurface.CervicalPalatal,
	[ToothToothWearZone.Lingual]: ToothSurface.CervicalLingual,
};

const DENTToothAbrasion = ({ data, toothViewData }: Props) => {
	return (
		<>
			<defs>
				<linearGradient id='linearBeige'>
					<stop offset='0%' stopColor='rgba(196,180,166,0.4)' />
					<stop offset='50%' stopColor='rgba(150,125,106,0.8)' />
					<stop offset='100%' stopColor='rgba(196,180,166,0.4)' />
				</linearGradient>
			</defs>

			<g opacity='0.7'>
				{data.pathology?.toothWear?.abrasion?.zones?.map((zone, index) => (
					<DENTToothSurface
						key={index}
						toothViewData={toothViewData}
						surface={ABRASION_SURFACES[zone]}
						patternId={'linearBeige'}
					/>
				))}
			</g>
		</>
	);
};

export default DENTToothAbrasion;
